import React, { useState, useEffect } from 'react'
import "../../CSS/SideBar.css";
import { Link, useNavigate } from 'react-router-dom';
import FontAwesome from 'react-fontawesome'
import { Icon } from '@iconify/react/dist/iconify.js';
import { useCookies } from 'react-cookie';
import Swal from 'sweetalert2';
import { useLocation } from "react-router-dom";

const SideBar = () => {

  const [showSubmenu, setShowSubmenu] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(['token']);
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [greeting, setGreeting] = useState('Hello');
  const isActive = (path) => location.pathname.startsWith(path);
  const linkClass = (path) => `sidebar-item ${location.pathname === path ? "active" : ""}`;
  const linkIcon = (path) => `sidebar-icon ${location.pathname === path ? "active" : ""}`;

  const toggleSubmenu = (event) => {
    event.stopPropagation(); // Prevent clicks inside submenu from closing it
    setShowSubmenu(prevState => !prevState);
  };

  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.startsWith("/AccountManagerMaster") ||
      location.pathname.startsWith("/AccountManageInformation") ||
      location.pathname.startsWith("/General") ||
      location.pathname.startsWith("/ClientGroup") ||
      location.pathname.startsWith("/Packages") ||
      location.pathname.startsWith("/PackageDetails") ||
      location.pathname.startsWith("/FormDetails") ||
      location.pathname.startsWith("/BusinessType") ||
      location.pathname.startsWith("/ClientSubscription") ||
      location.pathname.startsWith("/AppReleaseServer") ||
      location.pathname.startsWith("/AccountManagerMaster") ||
      location.pathname.startsWith("/UserAuthentication") ||
      // location.pathname.startsWith("/AccountManager") ||
      location.pathname.startsWith("/Support") ||
      location.pathname.startsWith("/SupportTemplate") ||
      location.pathname.startsWith("/ProductCategoryMaster") ||
      location.pathname.startsWith("/Transaction") ||
      location.pathname.startsWith("/WebTemplate") ||
      location.pathname.startsWith("/PaymentGateway") ||
      location.pathname.startsWith("/NotificationPopup") ||
      location.pathname.startsWith("/CouponMaster") ||
      location.pathname.startsWith("/PlanMaster") ||
      location.pathname.startsWith("/HelpDesk") 
    ) {
      setShowSubmenu(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const closeOnResize = () => {
      if (window.innerWidth > 1024) setMobileOpen(false);
    };
    window.addEventListener('resize', closeOnResize);
    return () => window.removeEventListener('resize', closeOnResize);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('sidebar-drawer-open', mobileOpen);
    return () => document.body.classList.remove('sidebar-drawer-open');
  }, [mobileOpen]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('authUser');
      if (stored) {
        const parsed = JSON.parse(stored);
        setUserName(parsed?.name || parsed?.Username || 'User');
      } else {
        setUserName('User');
      }
    } catch {
      setUserName('User');
    }
  }, []);

  useEffect(() => {
    const now = new Date();
    const hour = now.getHours();
    if (hour < 12) setGreeting('Good morning');
    else if (hour < 17) setGreeting('Good afternoon');
    else setGreeting('Good evening');
  }, []);

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "LOGOUT",
      text: "Are you sure you want to LogOut?",
      //icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yess !!",
      width: "300px",
      customClass: {
        title: "swal2-custom-title",
        confirmButton: "my-confirm-button",
        cancelButton: "my-cancel-button",

        popup: "swal2-custom-popup",
        htmlContainer: "swal2-custom-text",
        icon: "swal2-custom-icon",
      },
    })
    if (result.isConfirmed) {
      removeCookie('token', { path: '/' });
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      navigate('/');
      window.location.reload();
    }
  };


  return (
    <>
      <button
        type="button"
        className="sidebar-mobile-toggle"
        aria-label="Open menu"
        onClick={() => setMobileOpen(true)}
      >
        <Icon icon="mdi:menu" />
      </button>
      {mobileOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setMobileOpen(false)}
        />
      )}
      <div className={`sidebar ${mobileOpen ? 'sidebar--open' : ''}`}>
        <button
          type="button"
          className="sidebar-mobile-close"
          aria-label="Close menu"
          onClick={() => setMobileOpen(false)}
        >
          <Icon icon="mdi:close" />
        </button>
      <div className="sidebar-header-sticky">
        <div className="sidebar-user">
          <img src="/logo.jpg" alt="Cherry" className="sidebar-user-logo" />
          <div>
            <div className="sidebar-user-label">{greeting}, </div>
            <div className="sidebar-user-name">{(userName || 'USER')}</div>
          </div>
        </div>
        {/* <h2 className="sidebar-title">Software Manager</h2> */}
      </div>
      <ul className="sidebar-list">
        <li>
          <div className='flex-arrowup-down'>
            <Link to="/Dashboard" className={linkClass("/Dashboard")}>
              <Icon icon="oui:home"  className={linkIcon("/Dashboard")} />
              <span className={`sidebar-text ${location.pathname.startsWith('/Dashboard') ? "active" : ""}`}>Home</span>
            </Link>
          </div>
        </li>
        <li>
          <div className='flex-arrowup-down' onClick={toggleSubmenu}>
            <Link className={'sidebar-item'}>
              <Icon icon="oui:integration-general" className={'sidebar-icon'} />
              <span className={`sidebar-text `}>General</span>
            </Link>
            <div className="submenu-toggle-icon">
              <Icon icon={showSubmenu ? "fe:drop-up" : "fe:drop-down"} className="submenu-toggle-icon" />
            </div>
          </div>
          {showSubmenu && (
            <ul className='submenu' onClick={(e) => e.stopPropagation()}>
              <li>
                <Link to="/AccountManagerMaster" className={linkClass("/AccountManagerMaster")} >
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/AccountManagerMaster")} />
                  <span className="submenu-text">Account Master</span>
                </Link>
              </li>
              <li>
                <Link to="/AccountManageInformation" className={linkClass("/AccountManageInformation")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/AccountManageInformation")} />
                  <span className="submenu-text">Account Manager Information</span>
                </Link>
              </li>
              <li>
                <Link to="/AppReleaseServer" className={linkClass("/AppReleaseServer")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/AppReleaseServer")} />
                  <span className="submenu-text">App Release Server</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/AccountManager" className="submenu-item">
                  <Icon icon="teenyicons:right-solid" className='sidebar-icon' />
                  <span className="submenu-text">Account Manager</span>
                </Link>
              </li> */}
              <li>
                <Link to="/BusinessType" className={linkClass("/BusinessType")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/BusinessType")} />
                  <span className="submenu-text">Business Types</span>
                </Link>
              </li>
              <li>
                <Link to="/General" className={linkClass("/General")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/General")} />
                  <span className="submenu-text">Client List</span>
                </Link>
              </li>
              <li>
                <Link to="/ClientGroup" className={linkClass("/ClientGroup")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/ClientGroup")}/>
                  <span className="submenu-text">Client Group</span>
                </Link>
              </li>
              <li>
                <Link to="/ClientSubscription" className={linkClass("/ClientSubscription")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/ClientSubscription")}/>
                  <span className="submenu-text">Client Subscription</span>
                </Link>
              </li>
              <li>
                <Link to="/CouponMaster" className={linkClass("/CouponMaster")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/CouponMaster")}/>
                  <span className="submenu-text">Coupon Master</span>
                </Link>
              </li>
              <li>
                <Link to="/FormDetails" className={linkClass("/FormDetails")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/FormDetails")}/>
                  <span className="submenu-text">Form Details</span>
                </Link>
              </li>
              <li>
                <Link to="/HelpDesk" className={linkClass("/HelpDesk")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/HelpDesk")}/>
                  <span className="submenu-text">Help Desk Master</span>
                </Link>
              </li>
              <li>
                <Link to="/NotificationPopup" className={linkClass("/NotificationPopup")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/NotificationPopup")}/>
                  <span className="submenu-text">Notification Info</span>
                </Link>
              </li>
              <li>
                <Link to="/ProductCategoryMaster" className={linkClass("/ProductCategoryMaster")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/ProductCategoryMaster")}/>
                  <span className="submenu-text">Product Category Master</span>
                </Link>
              </li>
               <li>
                <Link to="/PlanMaster" className={linkClass("/PlanMaster")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/PlanMaster")}/>
                  <span className="submenu-text">Plan Master</span>
                </Link>
              </li>
              <li>
                <Link to="/Packages" className={linkClass("/Packages")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/Packages")} />
                  <span className="submenu-text">Packages</span>
                </Link>
              </li>
              <li>
                <Link to="/PackageDetails" className={linkClass("/PackageDetails")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/PackageDetails")} />
                  <span className="submenu-text">Package Details</span>
                </Link>
              </li>
              <li>
                <Link to="/PaymentGateway" className={linkClass("/PaymentGateway")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/PaymentGateway")} />
                  <span className="submenu-text">Payment Gateway</span>
                </Link>
              </li>
              <li>
                <Link to="/Support" className={linkClass("/Support")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/Support")}/>
                  <span className="submenu-text">Support</span>
                </Link>
              </li>
              <li>
                <Link to="/SupportTemplate" className={linkClass("/SupportTemplate")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/SupportTemplate")} />
                  <span className="submenu-text">Support Template</span>
                </Link>
              </li>
              <li>
                <Link to="/Transaction" className={linkClass("/Transaction")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/Transaction")} />
                  <span className="submenu-text">Transaction</span>
                </Link>
              </li>
              {/* <li>
                <Link to="/AccountManagerMaster" className="submenu-item">
                  <Icon icon="teenyicons:right-solid" className='sidebar-icon' />
                  <span className="submenu-text">Account Manager</span>
                </Link>
              </li> */}
              <li>
                <Link to="/UserAuthentication" className={linkClass("/UserAuthentication")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/UserAuthentication")} />
                  <span className="submenu-text">User Authentication</span>
                </Link>
              </li>
              <li>
                <Link to="/WebTemplate" className={linkClass("/WebTemplate")}>
                  <Icon icon="teenyicons:right-solid" className={linkIcon("/WebTemplate")}/>
                  <span className="submenu-text">Web Template List</span>
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <div className='flex-arrowup-down'>
            <Link to="/Banner" className={linkClass("/Banner")}>
              {/* <i className="fas fa-user sidebar-icon"></i> */}
              {/* <Icon icon="icon-park-solid:setting" className='sidebar-icon' /> */}
              <Icon icon="material-symbols:planner-banner-ad-pt-outline-sharp" className={linkIcon("/Banner")} />
              <span className={`sidebar-text ${location.pathname.startsWith('/Banner') ? "active" : ""}`}>Banners</span>
            </Link>
          </div>
        </li>
        <li>
          <div className='flex-arrowup-down'>
            <Link to="/Setting" className={linkClass("/Setting")}>
              {/* <i className="fas fa-user sidebar-icon"></i> */}
              <Icon icon="icon-park-solid:setting" className={linkIcon("/Setting")}/>
              <span className={`sidebar-text ${location.pathname.startsWith('/Setting') ? "active" : ""}`}>Setting</span>
            </Link>
          </div>
        </li>
        {/* <li>
        <Link to="/contact" className="sidebar-item">
          <i className="fas fa-envelope sidebar-icon"></i>
          <span className="sidebar-text">Contact</span>
        </Link>
      </li> */}
        <li>
          <div className='flex-arrowup-down'>
            <Link to="#" className="sidebar-item" onClick={handleLogout}>
              <Icon icon="icon-park-solid:reload" className='sidebar-icon' style={{ color: '#c53a3a' }} />
              <span className="sidebar-text" style={{ color: '#c53a3a', fontWeight: 'bold' }}>Logout</span>
            </Link>
          </div>
        </li>
      </ul>
    </div>
    </>
  )
}

export default SideBar
